
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "@/env";
import { User } from "../types/auth-types";
import { getUserTimezone } from "@/data/timezones";
import { supabase } from "@/integrations/supabase/client";

// Create a Supabase client with the connection details
export const createSupabaseClient = (): SupabaseClient => {
  return supabase;
};

// Convert Supabase user data to our User type
export const mapUserProfile = (userId: string, email: string, userData: any): User => {
  return {
    id: userId,
    email: email,
    firstName: userData.first_name || "",
    lastName: userData.last_name || "",
    gender: userData.gender || "male",
    timezone: userData.timezone || getUserTimezone(),
    plan: userData.plan === 'pro' ? 'pro' : 'free'  // Map plan directly
  };
};

// Store demo user in localStorage
export const storeDemoUser = (demoUser: User): void => {
  localStorage.setItem('fyndtyme_demo_user', JSON.stringify(demoUser));
};

// Remove demo user from localStorage
export const removeDemoUser = (): void => {
  localStorage.removeItem('fyndtyme_demo_user');
};

// Get demo user from localStorage
export const getDemoUserFromStorage = (): User | null => {
  const demoUserJson = localStorage.getItem('fyndtyme_demo_user');
  if (demoUserJson) {
    try {
      return JSON.parse(demoUserJson);
    } catch (e) {
      console.error("Error parsing demo user from localStorage:", e);
      localStorage.removeItem('fyndtyme_demo_user');
    }
  }
  return null;
};

// Test Supabase connection
export const testSupabaseConnection = async (supabase: SupabaseClient): Promise<void> => {
  try {
    const { error } = await supabase.auth.getSession();
    if (error) {
      console.error("Supabase connection error:", error);
    } else {
      console.log("Supabase connection successful");
    }
  } catch (e) {
    console.error("Supabase test exception:", e);
  }
};
